import { tv } from "../../../variants/tv.js";
const radioSizeVariants = {
    16: {
        labelSlot: 'text-body3',
        radioRoot: 'w-4 h-4',
        radioIndicator: 'before:w-[6px] before:h-[6px]'
    },
    20: {
        labelSlot: 'text-body2',
        radioRoot: 'w-4 h-4',
        radioIndicator: 'before:w-[8px] before:h-[8px]'
    },
    24: {
        labelSlot: 'text-body1',
        radioRoot: 'w-6 h-6',
        radioIndicator: 'before:w-[10px] before:h-[10px]'
    }
};
const radioSizes = Object.keys(radioSizeVariants);
const RadioEmphasisVariants = {
    regular: {
        labelSlot: 'text-primary-13',
        radioRoot: [
            'bg-primary-1 border border-primary-6 ',
            'hover:border-primary-10 focus-visible:outline-primary-8',
            'data-checked:bg-primary-8 data-checked:border-primary-8',
            'hover:data-checked:bg-primary-9 hover:data-checked:border-primary-9'
        ],
        radioIndicator: 'data-checked:before:bg-primary-1 data-disabled:data-checked:before:bg-primary-6',
        helperSlot: 'text-primary-1 group-[.disabled]:text-primary-1/40',
        textRightSlot: 'text-primary-10 group-[.disabled]:text-primary-1/40'
    },
    medium: {
        labelSlot: 'text-primary-13',
        radioRoot: [
            'bg-primary-1/60 border border-primary-6',
            'hover:border-primary-10 focus-visible:outline-primary-8',
            'data-checked:bg-primary-8 data-checked:border-primary-8',
            'hover:data-checked:bg-primary-9 hover:data-checked:border-primary-9'
        ],
        radioIndicator: 'data-checked:before:bg-primary-1 data-disabled:data-checked:before:bg-primary-6',
        helperSlot: 'text-primary-1 group-[.disabled]:text-primary-1/40',
        textRightSlot: 'text-primary-10 group-[.disabled]:text-primary-1/40'
    },
    bold: {
        labelSlot: 'text-primary-1',
        radioRoot: [
            'bg-primary-1/20 border border-primary-1/40',
            'hover:border-primary-1 focus-visible:outline-primary-1',
            'data-checked:bg-primary-1 data-checked:border-primary-1',
            'hover:data-checked:bg-primary-1/80  hover:data-checked:border-primary-1/80'
        ],
        radioIndicator: 'data-checked:before:bg-primary-8 data-disabled:data-checked:before:bg-primary-1/40',
        helperSlot: 'text-primary-1 group-[.disabled]:text-primary-1/40',
        textRightSlot: 'text-primary-10 group-[.disabled]:text-primary-1/40'
    }
};
const RadioDisabledStateVariants = {
    false: {
        containerSlot: 'group',
        labelSlot: 'hover:before:bg-primary-2 before:-z-1 relative cursor-pointer before:absolute before:inset-0 before:rounded-xl before:border-0 before:transition before:duration-300',
        helperSlot: 'hover:before:bg-primary-2 text-primary-13 before:-z-1 relative cursor-pointer before:absolute before:inset-0 before:-m-2 before:rounded-xl before:border-0 before:transition before:duration-300',
        textRightSlot: 'cursor-pointer text-primary-10'
    },
    true: {
        containerSlot: 'group data-disabled:cursor-not-allowed',
        labelSlot: 'has-data-disabled:cursor-not-allowed',
        helperSlot: 'text-primary-6 has-data-disabled:cursor-not-allowed',
        textRightSlot: 'text-primary-6 has-data-disabled:cursor-not-allowed',
        imageSlot: 'has-data-disabled:cursor-not-allowed'
    }
};
const radioEmphases = Object.keys(RadioEmphasisVariants);
const radioButtonVariants = tv({
    slots: {
        containerSlot: 'flex flex-1 flex-col items-start text-left has-data-disabled:cursor-not-allowed',
        labelSlot: [
            'items-normal flex items-center gap-2 rounded-md border-4 border-solid border-transparent text-left leading-tight hover:bg-primary-2',
            'has-data-disabled:cursor-not-allowed has-data-disabled:bg-transparent'
        ],
        radioRoot: 'inline-flex cursor-pointer items-center justify-center rounded-full transition hover:shadow-input-hover focus-visible:outline-2 focus-visible:outline-offset-2 data-checked:transition data-disabled:cursor-not-allowed data-disabled:shadow-none',
        radioIndicator: 'flex transition before:rounded-full data-checked:transition data-unchecked:hidden',
        iconSlot: 'no-underline transition group-hover:no-underline hover:no-underline',
        helperSlot: 'display-block items-normal flex w-full text-left text-body3 leading-tight has-data-disabled:cursor-not-allowed',
        textRightSlot: 'flex justify-end pt-0 text-body3 text-primary-10 has-data-disabled:cursor-not-allowed',
        imageSlot: 'inline-block self-center overflow-hidden bg-neutral-2 has-data-disabled:cursor-not-allowed'
    },
    variants: {
        emphasis: RadioEmphasisVariants,
        size: radioSizeVariants,
        disabled: RadioDisabledStateVariants,
        isRadioGroup: {
            true: {}
        },
        layout: {
            vertical: {},
            horizontal: {}
        }
    },
    compoundVariants: [
        {
            isRadioGroup: true,
            layout: 'vertical',
            class: {
                labelSlot: 'w-full py-1'
            }
        },
        {
            disabled: true,
            emphasis: 'regular',
            class: {
                labelSlot: 'text-primary-6',
                radioRoot: [
                    'border-primary-5 bg-primary-2 hover:border-primary-5',
                    'data-checked:border-primary-2 data-checked:bg-primary-2',
                    'hover:data-checked:border-primary-2 hover:data-checked:bg-primary-2'
                ]
            }
        },
        {
            disabled: true,
            emphasis: 'medium',
            class: {
                labelSlot: 'text-primary-6',
                radioRoot: [
                    'border-primary-5 bg-primary-1/60 hover:border-primary-5',
                    'data-checked:border-primary-1/60 data-checked:bg-primary-1/60',
                    'hover:data-checked:border-primary-1/60 hover:data-checked:bg-primary-1/60'
                ]
            }
        },
        {
            disabled: true,
            emphasis: 'bold',
            class: {
                labelSlot: 'text-primary-1/40',
                radioRoot: [
                    'border-primary-1/20 bg-primary-1/20 hover:border-primary-1/20',
                    'data-checked:border-primary-1/20 data-checked:bg-primary-1/20',
                    'hover:data-checked:border-primary-1/20 hover:data-checked:bg-primary-1/20'
                ]
            }
        }
    ],
    defaultVariants: {
        emphasis: 'regular',
        size: '20',
        disabled: false,
        isRadioGroup: false,
        layout: 'vertical'
    }
});
export { RadioDisabledStateVariants, RadioEmphasisVariants, radioButtonVariants, radioEmphases, radioSizeVariants, radioSizes };
